// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"8a48b7a9205de903","332":"c31f0453c739f642","367":"3c5890780482ccfe","735":"4be63a2b82bd420c"}[chunkId] + ".js";
};